import graphqlClient from "../../../apollo";

class InviraRoleProvider {

    findRole(id) {
        return graphqlClient.query({
            query: require('./gql/adminInviraRoleFind.graphql'),
            variables: { id: id },
            fetchPolicy: "network-only"
        })
    }

    fetchRoles(companyId = null) {
        return graphqlClient.query({
            query: require('./gql/adminInviraRoleFetch.graphql'),
            variables: { companyId },
            fetchPolicy: "network-only"
        })
    }

    paginateRoles(companyId, pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/adminInviraRolePaginate.graphql'),
            variables: { companyId, pageNumber, itemsPerPage, search, orderBy, orderDesc },
            fetchPolicy: "network-only"
        })
    }

    fetchRolesByCompany(companyId) {
        return graphqlClient.query({
            query: require('./gql/adminInviraRoleFetchByCompany.graphql'),
            variables: { companyId },
            fetchPolicy: "network-only"
        })
    }

    findRoleCompany(roleId) {
        return graphqlClient.query({
            query: require('./gql/adminInviraRoleCompanyFind.graphql'),
            variables: { roleId },
            fetchPolicy: "network-only"
        })
    }

    assignRoleToUser(userId, roleId) {
        return graphqlClient.mutate({
            mutation: require('./gql/adminInviraUserAssignRole.graphql'),
            variables: { userId, roleId }
        })
    }

    roleUpdate(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/adminInviraRoleUpdate.graphql'),
            variables: { 
                id: form.id, 
                name: form.name, 
                permissions: form.permissions, 
                childRoles: form.childRoles 
            }
        })
    }

    roleDelete(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/adminInviraRoleDelete.graphql'),
            variables: { id }
        })
    }

    roleCreate(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/adminInviraRoleCreate.graphql'),
            variables: { 
                name: form.name, 
                permissions: form.permissions, 
                childRoles: form.childRoles,
                companyId: form.companyId
            }
        })
    }

    assignRoleToCompany(roleId, companyId) {
        return graphqlClient.mutate({
            mutation: require('./gql/adminInviraAssignRoleToCompany.graphql'),
            variables: { roleId, companyId }
        })
    }

    removeRoleFromCompany(roleId) {
        return graphqlClient.mutate({
            mutation: require('./gql/adminInviraRemoveRoleFromCompany.graphql'),
            variables: { roleId }
        })
    }

}

export default new InviraRoleProvider()

